export default "/images/195083fed04397ef452e66a3e65a4d41.avif";